import { render, staticRenderFns } from "./Estatisticas.vue?vue&type=template&id=10b2f006"
import script from "./Estatisticas.vue?vue&type=script&lang=ts"
export * from "./Estatisticas.vue?vue&type=script&lang=ts"
import style0 from "./Estatisticas.vue?vue&type=style&index=0&id=10b2f006&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports